export default __webpack_public_path__ + "static/media/sand2.69d9dde9.png";